import { Component, Input, Inject } from "@angular/core";


import { LettersService } from "../../../../letters/letters.service";

import { Rule, SideEffect, SendEmailConfig, TextTemplate } from "../../../../common/models/flow.dto";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: "side-effect-email",
    templateUrl: "./side-effect-email.component.html",
    standalone: false
})
export class SideEffectEmailComponent {
    public _sideEffect: SideEffect;

    set sideEffect(value: SideEffect) {
        this._sideEffect = value;
        if (!this.sideEffect.configuration) {
            this._sideEffect.configuration = {};
        }
        this._fixConfig(this._sideEffect.configuration);
    }

    get sideEffect(): SideEffect {
        return this._sideEffect;
    }

    get conf(): SendEmailConfig {
        return this._sideEffect.configuration as SendEmailConfig;
    }

    constructor(
        private lettersService: LettersService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.sideEffect = data.sideEffect;
    }

    removeCCAddressRule(index: number) {
            this.conf.ccAddressRules.splice(index, 1);
    }

    removeToAddressRule(index: number) {
        if (index > 0 && index <= this.conf.toAddressRules.length)
            this.conf.toAddressRules.splice(index, 1);
    }

    addCCAddressRule() {
        this.conf.ccAddressRules.push({
            name: (this.conf.ccAddressRules.length + 1).toString(),
            ruleId: (this.conf.ccAddressRules.length + 1).toString(),
            expression: ""
        })
    }

    addToAddressRule() {
        this.conf.toAddressRules.push({
            name: (this.conf.toAddressRules.length + 1).toString(),
            ruleId: (this.conf.toAddressRules.length + 1).toString(),
            expression: ""
        })
    }

    bodyChanged() {
        this._templateContentChanged(this.conf.body);
    }

    subjectChanged() {
        this._templateContentChanged(this.conf.subject);
    }

    public _templateContentChanged(template: TextTemplate) {
        var newRules = this.lettersService.extractRules(template.content, "[", "]");
        var preserve = template.transforms.filter(r => newRules.findIndex(nr => nr.name === r.name) >= 0);
        var additional = newRules.filter(nr => template.transforms.findIndex(r => r.name === nr.name) === -1);
        template.transforms = preserve.concat(additional);
    }

    public _fixConfig(seconf: any): void {
        if (!seconf.subject) {
            seconf.subject = {};
        }
        if (!seconf.subject.content) {
            seconf.subject.content = "";
        }
        if (!seconf.subject.transforms) {
            seconf.subject.transforms = [];
        }
        if (!seconf.body) {
            seconf.body = {};
        }
        if (!seconf.body.content) {
            seconf.body.content = "";
        }
        if (!seconf.body.transforms) {
            seconf.body.transforms = [];
        }
        if (!seconf.toAddressRules) {
            seconf.toAddressRules = [];
        }
        if (!seconf.ccAddressRules) {
            seconf.ccAddressRules = [];
        }
        if (!seconf.bccAddressRules) {
            seconf.bccAddressRules = [];
        }
    }
}
